import { API_URL } from "../utils/constants";

const login = async (email: string, password: string) => {
  return await fetch(`${API_URL}/auth/email-password`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({ email, password }),
  })
    .then((res) => res.json())
    .then((res) => res)
    .catch((err) => console.log(err));
};

const sendOtp = async (email: string) => {
  return await fetch(`${API_URL}/auth/email-otp`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({ email }),
  })
    .then((res) => res.json())
    .then((res) => res)
    .catch((err) => console.log(err));
};
const verifyOtp = async (email: string, otp: number) => {
  return await fetch(`${API_URL}/auth/email-otp/verify`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({ email, otp, role: "user" }),
  })
    .then((res) => res.json())
    .then((res) => res)
    .catch((err) => console.log(err));
};

const acceptTermsOfUsage = async (id: string) => {
  return await fetch(`${API_URL}/accept-terms-of-usage`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({ id }),
  })
    .then((res) => res.json())
    .then((res) => res)
    .catch((err) => console.log(err));
};

const signInWithGoogle = async () =>
  window.open(`${API_URL}/auth/google/user`, "_self");

const authStatus = async () => {
  return await fetch(`${API_URL}/authStatus`, { credentials: "include" })
    .then((res) => res.json())
    .then((res) => res)
    .catch((err) => console.log(err));
};

const logout = async () => {
  return await fetch(`${API_URL}/logout`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    credentials: "include",
  })
    .then((res) => res.json())
    .then((res) => res)
    .catch((err) => console.log(err));
};

const authApi = {
  login,
  authStatus,
  signInWithGoogle,
  sendOtp,
  verifyOtp,
  acceptTermsOfUsage,
  logout,
};

export default authApi;
